import "core-js/modules/es6.array.find-index";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _slicedToArray from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import _typeof from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.constructor";
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/**
 * num 小于0，左缩进num*2个空格； 大于0，右缩进num*2个空格。
 * @param {string} str 代码
 * @param {number} num 缩进次数
 * @param {number} len 【可选】缩进单位，空格数
 */
export function indent(str, num) {
  var len = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  if (num === 0) return str;
  var isLeft = num < 0;
  var result = [];
  var reg;
  var spaces = '';
  if (isLeft) {
    num *= -1;
    reg = new RegExp("(^\\s{0,".concat(num * len, "})"), 'g');
  } else {
    for (var i = 0; i < num * len; i++) spaces += ' ';
  }
  str.split('\n').forEach(function (line) {
    line = isLeft ? line.replace(reg, '') : spaces + line;
    result.push(line);
  });
  return result.join('\n');
}

// 首字母大小
export function titleCase(str) {
  return str.replace(/( |^)[a-z]/g, function (L) {
    return L.toUpperCase();
  });
}

// 下划转驼峰
export function camelCase(str) {
  return str.replace(/-[a-z]/g, function (str1) {
    return str1.substr(-1).toUpperCase();
  });
}
export function isNumberStr(str) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str);
}
export var exportDefault = 'export default ';
export var beautifierConf = {
  html: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'separate',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: false,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true
  },
  js: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'normal',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: true,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true
  }
};
function stringify(obj) {
  return JSON.stringify(obj, function (key, val) {
    if (typeof val === 'function') {
      return "".concat(val);
    }
    return val;
  });
}
function parse(str) {
  JSON.parse(str, function (k, v) {
    if (v.indexOf && v.indexOf('function') > -1) {
      return eval("(".concat(v, ")"));
    }
    return v;
  });
}
export function jsonClone(obj) {
  return parse(stringify(obj));
}

// 深拷贝对象
export function deepClone(obj) {
  var _toString = Object.prototype.toString;

  // null, undefined, non-object, function
  if (!obj || _typeof(obj) !== 'object') {
    return obj;
  }

  // DOM Node
  if (obj.nodeType && 'cloneNode' in obj) {
    return obj.cloneNode(true);
  }

  // Date
  if (_toString.call(obj) === '[object Date]') {
    return new Date(obj.getTime());
  }

  // RegExp
  if (_toString.call(obj) === '[object RegExp]') {
    var flags = [];
    if (obj.global) {
      flags.push('g');
    }
    if (obj.multiline) {
      flags.push('m');
    }
    if (obj.ignoreCase) {
      flags.push('i');
    }
    return new RegExp(obj.source, flags.join(''));
  }
  var result = Array.isArray(obj) ? [] : obj.constructor ? new obj.constructor() : {};
  for (var key in obj) {
    result[key] = deepClone(obj[key]);
  }
  return result;
}

/**
 * 金额转中文
 * 思路：                       
 *                              个
 *      十     百      千       万
 *      十万   百万    千万     亿 
 *      十亿   百亿    千亿    
 *                              
 *                              1
 *      2      3       4        5
 *      6      7       8        9   
 *      10
 * 
 * 计算步骤
 * 1. 获取当前数值大小
 * 2. 排除个位后 数值按个，十，百，千有规律的重复 所以计算其和4的余数 pos % 4
 * 3. pos = 0 ~ 3 没有最大单位
 *    pos = 4 ~ 7 最大单位是万
 *    pos = 8 ~ 11 最大单位是亿
 * pos / 4 的整数就是最大单位
 * 
 */
export function getAmountChinese(val) {
  var amount = +val;
  if (Number.isNaN(amount) || amount < 0) return '';
  var NUMBER = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  var N_UNIT1 = ['', '拾', '佰', '仟'];
  var N_UNIT2 = ['', '万', '亿'];
  var D_UNIT = ['角', '分', '厘', '毫'];
  var _amount$toString$spli = amount.toString().split('.'),
    _amount$toString$spli2 = _slicedToArray(_amount$toString$spli, 2),
    integer = _amount$toString$spli2[0],
    decimal = _amount$toString$spli2[1];
  if (integer && integer.length > 12) return '金额过大无法计算';
  var res = '';
  // 整数部分
  if (integer) {
    for (var i = 0, len = integer.length; i < len; i++) {
      var num = integer.charAt(i);
      var pos = len - i - 1; // 排除个位后 所处的索引位置
      if (num === '0') {
        // 当前位 等于 0 且下一位也等于 0 则可跳过计算
        if (i === len - 1) {
          if (integer.length === 1) res += '零'; // 0.35 这种情况不可跳过计算
          break;
        }
        if (integer.charAt(i + 1) === '0') continue;
      }
      res += NUMBER[num];
      if (parseInt(num)) res += N_UNIT1[pos % 4];
      if (pos % 4 === 0) res += N_UNIT2[Math.floor(pos / 4)];
    }
  }
  res += '圆';
  // 小数部分
  if (parseInt(decimal)) {
    for (var _i = 0; _i < 4; _i++) {
      var _num = decimal.charAt(_i);
      if (parseInt(_num)) res += NUMBER[_num] + D_UNIT[_i];
    }
  } else {
    res += '整';
  }
  return res;
}
/**
 * 将用户输入的连续单个数字合并为一个数
 * @param {Array} expressions - 记录计算表达式的数组
 * @returns {Array} 新的数组
 */
export var mergeNumberOfExps = function mergeNumberOfExps(expressions) {
  var res = [];
  var isNumChar = function isNumChar(n) {
    return /^[\d|\.]$/.test(n);
  };
  for (var i = 0; i < expressions.length; i++) {
    if (i > 0 && isNumChar(expressions[i - 1]) && isNumChar(expressions[i])) {
      res[res.length - 1] += expressions[i];
      continue;
    }
    res.push(expressions[i]);
  }
  return res;
};
/**
 * 校验表达式是否符合计算法则
 * @param {Array} expressions - 合并数字后的表达式数组
 * @returns {Boolean}
 */
export var validExp = function validExp(expressions) {
  var mergeNum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var temp = mergeNum ? mergeNumberOfExps(expressions) : expressions;
  var arr = temp.filter(function (t) {
    return !'()'.includes(t);
  });
  // 去括号后 length应该为奇数  并且第一个字符和最后一个字符应该为数字而非计算符号
  if (temp.length % 2 === 0 || arr.length % 2 === 0 || Number.isNaN(+arr[0]) || Number.isNaN(+arr[arr.length - 1])) {
    return false;
  }
  for (var i = 0; i < arr.length - 1; i += 2) {
    if (typeof +arr[i] !== 'number' || !Number.isNaN(+arr[i + 1])) return false;
  }
  return true;
};
/**
 * 中缀转后缀（逆波兰 Reverse Polish Notation）
 * @param {Array} exps - 中缀表达式数组
 */
export var toRPN = function toRPN(exps) {
  var s1 = []; // 符号栈
  var s2 = []; // 输出栈
  var getTopVal = function getTopVal(stack) {
    return stack.length > 0 ? stack[stack.length - 1] : null;
  };
  var levelCompare = function levelCompare(c1, c2) {
    var getIndex = function getIndex(c) {
      return ['+-', '×÷', '()'].findIndex(function (t) {
        return t.includes(c);
      });
    };
    return getIndex(c1) - getIndex(c2);
  };
  exps.forEach(function (t) {
    if (typeof t === 'string' && Number.isNaN(Number(t))) {
      // 是符号
      if (t === '(') {
        s1.push(t);
      } else if (t === ')') {
        var popVal;
        do {
          popVal = s1.pop();
          popVal !== '(' && s2.push(popVal);
        } while (s1.length && popVal !== '(');
      } else {
        var topVal = getTopVal(s1);
        if (!topVal) {
          // s1 为空 直接push
          s1.push(t);
        } else {
          while (topVal && topVal !== '(' && levelCompare(topVal, t) >= 0) {
            // 优先级 >= t 弹出到s2
            s2.push(s1.pop());
            topVal = getTopVal(s1);
          }
          s1.push(t);
        }
      }
      return;
    }
    s2.push(t); // 数字直接入栈
  });
  while (s1.length) {
    s2.push(s1.pop());
  }
  return s2;
};
/**
 * 计算后缀表达式的值
 * @param {Array} rpnExps - 后缀表达式
 */
export var calcRPN = function calcRPN(rpnExps) {
  rpnExps = rpnExps.concat();
  var calc = function calc(x, y, type) {
    var a1 = Number(x),
      a2 = Number(y);
    switch (type) {
      case '+':
        return a1 + a2;
      case '-':
        return a1 - a2;
      case '×':
        return a1 * a2;
      case '÷':
        return a1 / a2;
    }
  };
  for (var i = 2; i < rpnExps.length; i++) {
    if ('+-×÷'.includes(rpnExps[i])) {
      var val = calc(rpnExps[i - 2], rpnExps[i - 1], rpnExps[i]);
      rpnExps.splice(i - 2, 3, val);
      i = i - 2;
    }
  }
  return rpnExps[0];
};
/**
 * 简易防抖函数
 * @param {Function} func -防抖目标函数
 * @param {Number} gap - 防抖时间间隔
 */
export var debounce = function debounce(func, gap) {
  var timer;
  return function () {
    var _arguments = arguments,
      _this = this;
    timer && clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(_this, _arguments);
    }, gap);
  };
};